import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, merge, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';

import { FeedbackApiService } from '@paymash/sdk/api/v2';
import { FeedbackActions, FeedbackApiActions } from './feedback.actions';
import { NotificationActions } from '@public-page/store/notification';
import { selectCompanyUuid } from '@public-page/store/company';
import { SuccessMessageKeysEnum } from '@modules/core/enums';
import { ErrorMessageKeyService } from '@modules/core/services';

@Injectable()
export class FeedbackEffects {
  constructor(
    private actions$: Actions,
    private feedbackApiService: FeedbackApiService,
    private store: Store,
    private errorMessageKeyService: ErrorMessageKeyService
  ) {}

  sendFeedback$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FeedbackActions.send),
      map((action) => action.payload),
      concatLatestFrom(() => [this.store.select(selectCompanyUuid)]),
      exhaustMap(([payload, companyUuid]) =>
        this.feedbackApiService.sendFeedback(companyUuid as string, payload).pipe(
          switchMap(() => [
            FeedbackApiActions.sendSuccess({ feedback: { status: 'SENT' } }),
            NotificationActions.addSuccess({ messageKey: SuccessMessageKeysEnum.FEEDBACK_SENT }),
          ]),
          catchError((error) => {
            const messageKey = this.errorMessageKeyService.getKey(error);
            return merge([FeedbackApiActions.sendFailure(), NotificationActions.addError({ messageKey })]);
          })
        )
      )
    );
  });
}
